import { useQuery } from 'react-query';
import { api } from '../api';

interface IParams {
  docto: string;
  dtInicial: string | undefined;
  dtFinal: string | undefined;
  tipoPeriodo: 'A' | 'E' | string;
  pagina: number;
  limite: number;
}

export interface IAccompanimentProps {
  id: string;
  dtPedido: string;
  dtAntecipacao: string;
  vlTotBruto: number;
  ptTxSimulado: number;
  vlTotLiqSimulado: number;
  vlTotLiqReal: number;
  dtOperInc: Date;
  vlTotTxSimulado: number;
  vlTotTxReal: number;
  situacao: number;
  situacaoDescricao: string;
};

export async function getAcompanhamento(
  params: IParams
): Promise<IAccompanimentProps[]> {
  const { data } = await api.get('/anticipations/antecipacao', {
    params
  });

  return data;
}

export function useAcompanhamento(params: IParams) {
  return useQuery(
    [
      'acompanhamento',
      params.docto,
      params.dtInicial,
      params.dtFinal,
      params.tipoPeriodo,
      params.pagina,
      params.limite
    ],
    () => getAcompanhamento({ ...params }),
    {
      enabled: String(api.defaults.headers.common.authorization).length > 10 && !!params.docto,
      staleTime: 1000 * 60 * 5, // 5 min
      retry: 2
    }
  );
}
